/* Backend-aligned choice lists for select fields. */

/* Generic helper — picks the most descriptive label-like field on a record.
 * Used as a fallback in FK_RESOURCES.labelFor so any future Django field
 * named `<thing>_label` (or `dosya_label`, `araci_label`, `parca_label`,
 * etc.) is rendered automatically without extra config. */
const pickLabel = (o, ...fallbackKeys) => {
    if (!o) return "";
    // Prefer any *_label field on the record itself
    for (const k of Object.keys(o)) {
        if (/_label$/i.test(k) && o[k]) return o[k];
    }
    for (const k of fallbackKeys) {
        if (o[k]) return o[k];
    }
    return o.id !== undefined ? `#${o.id}` : "";
};

const toOptions = (pairs) =>
    pairs.map(([value, label]) => ({ value, label }));

export const BASVURU_TURLERI = toOptions([
    ["KASKO", "Kasko"],
    ["TRAFIK", "Trafik"],
]);

export const DOSYA_DURUMLARI = toOptions([
    ["YENI", "Yeni"],
    ["EVRAK_EKSIK", "Evrak Eksik"],
    ["BEDENI", "Bedeni"],
    ["BASVURU", "Başvuru"],
    ["HASAR_DOSYASI", "Hasar Dosyası"],
    ["ON_TAHKIM", "Ön Tahkim"],
    ["TAHKIM", "Tahkim"],
    ["HAKEM_HEYETI", "Hakem Heyeti"],
    ["ICRA", "İcra"],
    ["ICRA_HAZIRLIK", "İcra Hazırlık"],
    ["ICRA_TAKIP", "İcra Takip"],
    ["ICRA_HACIZ", "İcra Haciz"],
    ["ICRA_TAHSILAT", "İcra Tahsilat"],
    ["DAVA_HAZIRLIK", "Dava Hazırlık"],
    ["DAVA_DILEKCE", "Dava Dilekçe"],
    ["DAVA_DURUSMA", "Dava Duruşma"],
    ["DAVA_KARAR", "Dava Karar"],
    ["KAPATILDI", "Kapatıldı"],
]);

export const DOSYA_TIPLERI = toOptions([
    ["TAHKIM", "Tahkim"],
    ["ICRA", "İcra"],
    ["DAVA", "Dava"],
]);

export const TAHKIM_DOSYA_DURUMLARI = toOptions([
    ["YENI", "Yeni"],
    ["EVRAK_EKSIK", "Evrak Eksik"],
    ["BEDENI", "Bedeni"],
    ["BASVURU", "Başvuru"],
    ["HASAR_DOSYASI", "Hasar Dosyası"],
    ["ON_TAHKIM", "Ön Tahkim"],
    ["TAHKIM", "Tahkim"],
    ["HAKEM_HEYETI", "Hakem Heyeti"],
    ["ICRA", "İcra"],
    ["KAPATILDI", "Kapatıldı"],
]);

export const ICRA_DOSYA_DURUMLARI = toOptions([
    ["YENI", "Yeni"],
    ["ICRA_HAZIRLIK", "İcra Hazırlık"],
    ["ICRA_TAKIP", "İcra Takip"],
    ["ICRA_HACIZ", "İcra Haciz"],
    ["ICRA_TAHSILAT", "İcra Tahsilat"],
    ["KAPATILDI", "Kapatıldı"],
]);

export const DAVA_DOSYA_DURUMLARI = toOptions([
    ["YENI", "Yeni"],
    ["DAVA_HAZIRLIK", "Dava Hazırlık"],
    ["DAVA_DILEKCE", "Dava Dilekçe"],
    ["DAVA_DURUSMA", "Dava Duruşma"],
    ["DAVA_KARAR", "Dava Karar"],
    ["KAPATILDI", "Kapatıldı"],
]);

export const BASVURU_KONULARI = toOptions([
    ["PERT_FARKI", "Pert Farkı"],
    ["DEGER_KAYBI", "Değer Kaybı"],
    ["YARALANMALI_KAZA", "Yaralanmalı Kaza"],
    ["OLUM_KAZASI", "Ölümlü Kaza"],
    ["SAIBE_DOSYASI", "Şaibe Dosyası"],
    ["YATAR", "Yatar Dosyası"],
    ["DIGER", "Diğer"],
]);

export const KUSUR_ORANLARI = toOptions([
    ["0", "%0"],
    ["25", "%25"],
    ["50", "%50"],
    ["75", "%75"],
    ["100", "%100"],
]);

export const ARAC_TIPLERI = toOptions([
    ["OTOMOBIL", "Otomobil"],
    ["MINIBUS", "Minibüs"],
    ["KAMYONET", "Kamyonet"],
    ["MOTOSIKLET", "Motosiklet"],
    ["KAMYON", "Kamyon"],
    ["OTOBUS", "Otobüs"],
    ["DIGER", "Diğer"],
]);

export const EVRAK_TURLERI = toOptions([
    ["RUHSAT", "Ruhsat"],
    ["VEKALET", "Vekalet"],
    ["TUTANAK", "Kaza Tespit Tutanağı"],
    ["KAZA_RESIM", "Kaza Resimleri"],
    ["EKSPER", "Eksper Raporu"],
    ["DILEKCE", "Dilekçe"],
    ["KUSUR", "Kusur Durumu"],
    ["ISLAH_DILEKCE", "Islah Dilekçesi"],
    ["GONDERI_BELGESI", "Gönderi Belgesi"],
    ["DIGER_EVRAK", "Diğer Evraklar"],
]);

/** Müvekkil.vekalet_durumu — Django: ALINDI / ALINMADI */
export const VEKALET_DURUMU = toOptions([
    ["ALINDI", "Alındı"],
    ["ALINMADI", "Alınmadı"],
]);

export const ARACI_ODEME_DURUM = toOptions([
    ["ODENDI", "Ödendi"],
    ["BEKLIYOR", "Bekliyor"],
    ["IPTAL", "İptal"],
]);

export const ODEME_TURLERI = toOptions([
    ["ON_ODEME", "Ön Ödeme"],
    ["GELEN_ODEME", "Gelen Ödeme"],
    ["ICRA_TAHSILAT", "İcra Tahsilatı"],
    ["ICRA_MASRAF", "İcra Masrafı"],
]);

export const FATURA_ODEME_DURUM = toOptions([
    ["ODENDI", "Ödendi"],
    ["ODEME_BEKLENIYOR", "Ödeme Bekleniyor"],
]);

export const ICRA_TAKIBI_DURUMLARI = toOptions([
    ["BASLATILDI", "Başlatıldı"],
    ["TAKIPTE", "Takipte"],
    ["TAHSIL_EDILDI", "Tahsil Edildi"],
    ["KAPANDI", "Kapandı"],
]);

export const ICRA_TAKIP_TURLERI = toOptions([
    ["ICRA", "İcra Takibi"],
    ["DAVA", "Dava Süreci"],
]);

export const EVRAK_ONAY_DURUMU = toOptions([
    ["BEKLIYOR", "Bekliyor"],
    ["ONAYLI", "Onaylı"],
    ["REDDEDILDI", "Reddedildi"],
]);

export const VEKALET_KAYIT_DURUMU = toOptions([
    ["ALINDI", "Alındı"],
    ["ALINMADI", "Alınmadı"],
]);

export const SIGORTA_BASVURU_DURUM = toOptions([
    ["taslak", "Taslak"],
    ["hazir", "Hazır"],
    ["gonderildi", "Gönderildi"],
]);

/* Generic "active/inactive" usable everywhere */
export const AKTIF_DURUMU = toOptions([
    ["aktif", "Aktif"],
    ["pasif", "Pasif"],
]);

/* ---------- Foreign-key (FK) resource configurations ----------
 * Used by SearchableSelect to know:
 *  - which resource to query
 *  - how to render the label of an option
 *  - which fields to send as `?search=...`
 */
export const FK_RESOURCES = {
    muvekkiller: {
        labelFor: (o) => {
            const name =
                o?.muvekkil_label ||
                [o?.ad, o?.soyad].filter(Boolean).join(" ") ||
                o?.unvan ||
                o?.ad_soyad ||
                o?.title ||
                `#${o?.id}`;
            const tc = o?.tc_kimlik_no || o?.tc_no;
            return tc ? `${name} (${tc})` : name;
        },
        secondary: (o) => o?.telefon || o?.email || "",
    },
    filolar: {
        labelFor: (o) =>
            pickLabel(o, "firma_adi", "ticari_unvan", "ad", "unvan") ||
            (o?.id != null ? `Filo #${o.id}` : ""),
        secondary: (o) => o?.il || o?.telefon || o?.email || "",
    },
    "filo-araclari": {
        labelFor: (o) => {
            const plaka = o?.plaka || "";
            const mm = [o?.marka, o?.model].filter(Boolean).join(" ");
            if (plaka && mm) return `${plaka} — ${mm}`;
            return plaka || mm || pickLabel(o, "plaka") || "";
        },
        secondary: (o) => o?.filo_label || o?.filo?.firma_adi || "",
    },
    suruculer: {
        labelFor: (o) => pickLabel(o, "ad_soyad", "ad") || (o?.id != null ? `Sürücü #${o.id}` : ""),
        secondary: (o) => o?.telefon || o?.filo_label || "",
    },
    "araci-bildirimler": {
        labelFor: (o) => o?.baslik || (o?.id != null ? `Bildirim #${o.id}` : ""),
        secondary: (o) => o?.araci_label || o?.araci?.ad || "",
    },
    "sigorta-sirketleri": {
        labelFor: (o) => pickLabel(o, "ad", "unvan"),
        secondary: (o) => o?.yetkili || o?.telefon || "",
    },
    kullanicilar: {
        labelFor: (o) => {
            if (o?.__label) return o.__label;
            const name = [o?.first_name, o?.last_name].filter(Boolean).join(" ");
            return (
                pickLabel(o, "full_name", "ad_soyad") ||
                name ||
                o?.username ||
                (o?.id != null ? `Kullanıcı #${o.id}` : "")
            );
        },
        secondary: (o) => o?.email || o?.username || "",
    },
    aracilar: {
        labelFor: (o) =>
            pickLabel(o, "ad_soyad", "ad", "firma") ||
            [o?.ad, o?.soyad].filter(Boolean).join(" ") ||
            `#${o?.id}`,
        secondary: (o) => o?.firma || o?.email || o?.telefon || "",
    },
    "anlasmali-servisler": {
        labelFor: (o) => pickLabel(o, "ad"),
        secondary: (o) => o?.sehir || o?.telefon || "",
    },
    "masraf-turleri": {
        labelFor: (o) => pickLabel(o, "isim", "ad"),
        secondary: () => "",
    },
    odemeler: {
        labelFor: (o) => {
            const dosya =
                o?.sigorta_dosyasi_label ||
                o?.sigorta_dosyasi?.dosya_no ||
                "";
            const tur = o?.odeme_turu || "";
            if (dosya && tur) return `${dosya} · ${tur}`;
            return dosya || tur || (o?.id != null ? `Ödeme #${o.id}` : "");
        },
        secondary: (o) =>
            o?.odeme_miktari != null ? `₺${o.odeme_miktari}` : "",
    },
    "arac-parcalari": {
        labelFor: (o) => pickLabel(o, "ad", "isim", "parca_adi", "kod"),
        secondary: (o) => o?.grup || o?.kategori || o?.kod || "",
    },
    "arac-parcasi": {
        labelFor: (o) => pickLabel(o, "parca_adi", "ad", "isim", "parca_kodu"),
        secondary: (o) => o?.kategori || o?.parca_kodu || "",
    },
    "deger-kaybi-parcalari": {
        labelFor: (o) =>
            o?.parca_label ||
            o?.parca_adi ||
            o?.parca_bilgisi?.parca_adi ||
            o?.parca_bilgisi?.ad ||
            (typeof o?.parca === "object"
                ? o.parca?.parca_adi || o.parca?.ad
                : null) ||
            `#${o?.id}`,
        secondary: (o) => o?.islem_tipi_display || o?.islem_tipi || "",
    },
    "sigorta-dosyalari": {
        labelFor: (o) =>
            pickLabel(o, "dosya_label", "dosya_no") ||
            (o?.muvekkil_label ? `${o.muvekkil_label} — ${o.dosya_no || ""}` : "") ||
            `#${o?.id}`,
        secondary: (o) =>
            o?.muvekkil_label ||
            (o?.muvekkil?.ad
                ? `${o.muvekkil.ad} ${o.muvekkil.soyad || ""}`.trim()
                : o?.muvekkil_adi || ""),
    },
    "dava-dosyalari": {
        labelFor: (o) =>
            pickLabel(o, "dosya_label", "dosya_no", "esas_no"),
        secondary: (o) => o?.mahkeme || "",
    },
    "tahkim-dosyalari": {
        labelFor: (o) => pickLabel(o, "dosya_label", "dosya_no"),
        secondary: (o) => o?.konu || "",
    },
    dosyalar: {
        labelFor: (o) => pickLabel(o, "dosya_no", "baslik"),
        secondary: (o) => o?.tur || "",
    },
};

/* Field-name → FK resource heuristic.  When a field's value comes back from
 * the API as an `{id, ...}` object OR matches one of these names, we treat it
 * as a foreign-key field and render a SearchableSelect.
 * Used by the auto-discovery layer in EntityListPage / EntityForm.
 */
export const FK_FIELD_MAP = {
    muvekkil: "muvekkiller",
    muvekkiller: "muvekkiller",
    client: "muvekkiller",
    sigorta_sirketi: "sigorta-sirketleri",
    sigortaci: "sigorta-sirketleri",
    sirket: "sigorta-sirketleri",
    avukat: "kullanicilar",
    araci: "aracilar",
    aracilar: "aracilar",
    filo: "filolar",
    sigorta_dosya: "sigorta-dosyalari",
    sigorta_dosyasi: "sigorta-dosyalari",
    dava_dosya: "dava-dosyalari",
    dava_dosyasi: "dava-dosyalari",
    tahkim_dosya: "tahkim-dosyalari",
    tahkim_dosyasi: "tahkim-dosyalari",
    masraf_turu: "masraf-turleri",
    anlasmali_servis: "anlasmali-servisler",
    servis: "anlasmali-servisler",
};

/* Field-name → choices map for auto-discovered fields.  Lets the form pick
 * the right select options when the schema doesn't explicitly declare them.
 */
export const FIELD_CHOICES_MAP = {
    durum: DOSYA_DURUMLARI,
    dosya_durumu: DOSYA_DURUMLARI,
    basvuru_turu: BASVURU_TURLERI,
    basvuru_konusu: BASVURU_KONULARI,
    arac_tipi: ARAC_TIPLERI,
    kusur_orani: KUSUR_ORANLARI,
    evrak_turu: EVRAK_TURLERI,
    tur: EVRAK_TURLERI, // legacy/back-compat for older API responses
    vekalet_durumu: VEKALET_DURUMU,
    vekaletDurumu: VEKALET_DURUMU,
    odeme_durumu: ARACI_ODEME_DURUM,
};
